import { Badge } from "@/components/ui/badge";
import type { ProgramNewsReviewVerdict } from "@/services/adminProgramNews";
import { cn } from "@/lib/utils";
import Term from "./Term";

interface ReviewedBadgeProps {
  verdict: ProgramNewsReviewVerdict | null | undefined;
}

/** Shown on a row once the current admin has recorded a verdict. */
const ReviewedBadge = ({ verdict }: ReviewedBadgeProps) => {
  if (!verdict) return null;
  return (
    <Badge
      variant="outline"
      className={cn(
        verdict === "right"
          ? "border-green-600/40 bg-green-50 text-green-800"
          : "border-red-600/40 bg-red-50 text-red-800"
      )}
    >
      <Term term="reviewed">Reviewed: {verdict}</Term>
    </Badge>
  );
};

export default ReviewedBadge;
